<template>
  <div class="group-detail">
    <h1 class="common__main-title">Clock in / Waiting sign</h1>
    <div class="common__main-contener">
      <div class="common__main-content bg-white mb-4">
        <QrcodeStream
          :camera="camera"
          @decode="onDecode"
          @init="onInit"
          v-if="isShowCamera"
        >
          <div v-show="showScanConfirmation && reslut" class="scan-confirmation">
            <div v-if="reslut === 'success'">
              <font-awesome-icon class="check-circle" icon="check-circle"/>
              <h6 class="success-text text-center">{{resultMessage}}</h6>
            </div>
            <div v-if="reslut === 'error'">
              <font-awesome-icon class="exclamation-triangle" icon="exclamation-triangle"/>
              <h6 class="error-text">{{resultMessage}}</h6>
            </div>
          </div>
        </QrcodeStream>
        <p class="error-text">{{ error }}</p>
      </div>
      <div class="d-flex justify-content-center">
        <b-button
          pill
          variant="primary"
          @click="showReadCamera"
          class="w-50"
        >
          Read
        </b-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import moment from 'moment';
// @ts-expect-error 型チェック不要部分
import { QrcodeStream } from 'vue-qrcode-reader';
import { AxiosPromise } from 'axios';

export default Vue.extend({
  data(): {
    camera: string|null,
    error: string|null,
    reslut: string|null,
    resultMessage: string|null,
    isShowCamera: boolean,
    showScanConfirmation: boolean,
    } {
    return {
      camera: 'auto',
      error: '',
      reslut: '',
      resultMessage: '',
      isShowCamera: false,
      showScanConfirmation: false,
    }
  },

  components: {
    QrcodeStream,
  },

  methods: {
    showReadCamera(): void {
      this.isShowCamera = true;
    },

    async onDecode(result: string): Promise<void> {
      if (!result) return;

      this.camera = 'off'
      const currentTime = moment().format('HHmm');
      const parseResult = JSON.parse(result)
      const clockin = {
        ...parseResult,
        date: Number(parseResult.date),
        time: currentTime,
      };
      try {
        await this.$store.dispatch(
          'registerStamp',
          {
            userId: this.$store.state.auth.profile.id,
            stamp: clockin,
          },
        )
        this.reslut = 'success';
        this.resultMessage = 'success!';
        this.removeMessageAutomatically(500);
      } catch (error: any) {
        this.reslut = 'error';
        this.resultMessage = error.response.data.message;
        this.removeMessageAutomatically(500);
      }
    },

    async onInit(promise: AxiosPromise): Promise<void> {
      try {
        await promise
      } catch (error: any) {
        if (error.name === 'NotAllowedError') {
          this.error = 'ERROR: you need to grant camera access permisson'
        } else if (error.name === 'NotFoundError') {
          this.error = 'ERROR: no camera on this device'
        } else if (error.name === 'NotSupportedError') {
          this.error = 'ERROR: secure context required (HTTPS, localhost)'
        } else if (error.name === 'NotReadableError') {
          this.error = 'ERROR: is the camera already in use?'
        } else if (error.name === 'OverconstrainedError') {
          this.error = 'ERROR: installed cameras are not suitable'
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = 'ERROR: Stream API is not supported in this browser'
        } else if (error.name === 'InsecureContextError') {
          this.error = 'ERROR: camera access is only permitted in secure context. Use HTTPS or localhost rather than HTTP'
        } else {
          this.error = 'ERROR: Unexplained error'
        }
      } finally {
        this.showScanConfirmation = this.camera === 'off'
        this.reslut = '';
      }
    },

    removeMessageAutomatically(ms: number): void {
      setTimeout(() => {
        this.camera = 'auto'
      }, ms);
    },
  },
});
</script>

<style scoped>
.scan-confirmation {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, .8);
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}

.check-circle {
  color: #92D050;
  font-size: 100px;
  display: block;
  margin: auto;
}

.exclamation-triangle {
  color: #ee2b2b;
  font-size: 100px;
  display: block;
  margin: auto;
}
</style>
